import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import { PapiUser } from '@wix/da-papi-types';
import EmptyState from '../../EmptyState';
import { UserStream, Props as WidgetProps } from './UserStream';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../UserWidgets/_partials/WidgetBox';
import UserStreamConfigPopover from './UserStreamConfigPopover';

import s from './UserStreamBox.scss';

const UserStreamBox: React.FC<
  WidgetProps &
    WidgetBoxProps & {
      type: 'watchers' | 'watching';
      totalCount?: number;
      isOwner: boolean;
      profileOwnerUser: PapiUser;
      canSeeAll?: boolean;
      withConfig?: boolean;
    }
> = ({
  type,
  isEmpty,
  isOwner,
  canSeeAll,
  totalCount,
  widgetRemove,
  widgetMoveUp,
  widgetMoveDown,
  widgetMenuRenderer,
  section,
  zone,
  withConfig,
  ...props
}) => {
  const { t } = useTranslation();
  const navigateToDyW = () => {
    window.location.replace(Url.browseDeviantsYouWatchLink());
  };
  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t(`widgets.${type}.header`)}
      count={totalCount}
      seeAllUrl={Url.userLink(
        props.profileOwnerUser.username,
        `${USER_PROFILE_SECTION_PATHS.ABOUT}#${type}`
      )}
      hasMore={props.hasMore && canSeeAll}
      moduleId={props.moduleId}
      widgetMenuRenderer={
        withConfig
          ? close => (
              <UserStreamConfigPopover
                moduleId={props.moduleId}
                onClose={close}
              />
            )
          : undefined
      }
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={isEmpty}
      emptyView={
        isOwner ? (
          <EmptyState
            view="small"
            className={s['empty-state']}
            title={t(`widgets.${type}.empty.title.owner`)}
            subtitle={t(`widgets.${type}.empty.subtitle.owner`)}
            buttonLabel={t(`widgets.${type}.empty.CTALabel.owner`)}
            withButton={true}
            onButtonClick={navigateToDyW}
          />
        ) : null
      }
    >
      <UserStream {...props} />
    </WidgetBox>
  );
};
UserStreamBox.displayName = 'UserStreamBox';

export default UserStreamBox;
